import '../../sass/portfolio.scss'
import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import PersonalInfo from "./components/personal-info";
import Projects from "./components/projects";
import Activities from "./components/activities";

function Portfolio() {
  useEffect(() => {
    document.title = 'Tien Manh\'s Portfolio';
  }, []);

  const [currentPage, setCurrentPage] = useState(1);

  return (
    <div className={'portfolio'}>
      <div>
        <div className={'personal-info'} style={{width: currentPage === 1 ? '100vw' : '0vw'}}><PersonalInfo /></div>
        <div className={'projects'} style={{width: currentPage === 2 ? '100vw' : '0vw'}}><Projects page={currentPage} /></div>
        <div className={'activities'} style={{width: currentPage === 3 ? '100vw' : '0vw'}}><Activities /></div>
      </div>
      <div className={'button'}>
        <div className={'prev'} style={{display: currentPage === 1 ? 'None' : ''}}>
          <Button onClick={() => setCurrentPage(currentPage - 1)}><ArrowBackIosNewIcon /></Button>
        </div>
        <div className={'next'} style={{display: currentPage === 3 ? 'None' : ''}}>
          <Button onClick={() => setCurrentPage(currentPage + 1)}><ArrowForwardIosIcon /></Button>
        </div>
      </div>
    </div>
  )
}

export default Portfolio;
